import React from 'react';
import svtlibCookie from '@svt/cookie';

class CookieMessage extends React.Component {
    componentDidMount() {
        svtlibCookie('PlayCookieInformationRoot');
    }

    render() {
        return <div id="PlayCookieInformationRoot" className="play_cookie-information" />;
    }
}

export default CookieMessage;
